<template>
  <el-dialog
    title="客户联系人列表"
    :visible.sync="visible"
    width="1000px"
    @close="closed"
    @open="opened"
  >
    <ContactList
      :customerID="customerID"
      :serviceQuestID="serviceQuestID"
    ></ContactList>
  </el-dialog>
</template>

<script>
import ContactList from '@/views/customer/contact'

export default {
  components: {
    ContactList,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customerID: {
      type: Number,
      default: 0,
    },
    serviceQuestID: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
  created() {},
  methods: {
    opened() {
      //   if (this.versions.length > 0 && this.quotation.id > 0) {
      //     this.requestQuotationVersion()
      //   }
    },
    closed() {
      this.$emit('update:show', false)
      this.$emit('sended')
    },
  },
}
</script>

<style scoped>
.el-dialog__body .panel {
  padding: 0;
  box-shadow: none;
}
</style>